<template>
    <div class="container">
        <div class="row">
            <div class="col-md-8 offset-md-2">
                <div class="text-center mt-4 mb-4">
                    <h1 class="display-4">개인정보 처리방침</h1>
                </div>

                <div class="card mb-3">
                    <div class="card-body">
                        <h5 class="card-title">일반 조건</h5>
                        <p>
                            앱을 다운로드하거나 사용하면 본 약관이 자동으로 적용됩니다. 따라서 앱을 사용하기 전에 이를
                            주의 깊게 읽어주시기 바랍니다.
                        </p>
                        <p>
                            앱 또는 앱의 일부분, 당사의 상표를 어떤 방식으로든 복사하거나 수정할 수 없습니다.
                        </p>
                        <p>
                            앱의 소스 코드를 추출하려 하거나, 앱을 다른 언어로 번역하거나 파생 버전을 만들려고 해서도 안 됩니다.
                        </p>
                        <p>
                            앱 자체와 그와 관련된 모든 상표권, 저작권, 데이터베이스 권리 및 기타 지적 재산권은
                            여전히 Florian Zopf에게 귀속됩니다.
                        </p>
                    </div>
                </div>

                <div class="card mb-3">
                    <div class="card-body">
                        <h5 class="card-title">서비스 변경 및 요금</h5>
                        <p>
                            Florian Zopf는 앱이 가능한 한 유용하고 효율적으로 동작하도록 최선을 다하고 있습니다.
                        </p>
                        <p>
                            우리는 언제든지 어떠한 사유로든 앱을 변경하거나 서비스에 요금을 부과할 권리를 보유합니다.
                        </p>
                        <p>
                            무엇에 대해 비용을 지불하는지 명확히 안내하지 않고는 앱이나 서비스에 대해 요금을 청구하지 않습니다.
                        </p>
                    </div>
                </div>

                <div class="card mb-3">
                    <div class="card-body">
                        <h5 class="card-title">데이터 보안 및 개인정보 보호</h5>
                        <p>
                            Qwik VBT 앱은 서비스를 제공하기 위해 귀하가 제공한 개인정보를 저장하고 처리합니다.
                        </p>
                        <p>
                            온라인 모드 기능을 제공하기 위해 사용자 데이터를 클라우드에 저장합니다. 우리는 귀하의 데이터의
                            프라이버시와 보안을 매우 중요하게 여기며, 무단 접근, 공개, 변경, 파괴로부터 데이터를 보호하기 위해
                            업계 표준의 조치를 시행하고 있습니다.
                        </p>
                        <p>
                            다만 인터넷을 통한 전자적 저장 또는 전송 방법은 100% 안전하지 않으므로, 귀하의 데이터에 대한
                            절대적인 보안을 보장할 수는 없습니다.
                        </p>
                    </div>
                </div>

                <div class="card mb-3">
                    <div class="card-body">
                        <h5 class="card-title">제3자 서비스</h5>
                        <p>
                            앱은 약관을 고지하는 제3자 서비스를 사용합니다.
                        </p>
                        <p>
                            앱에서 사용하는 제3자 서비스 제공자의 약관 링크:
                        </p>
                        <ul>
                            <li><a href="https://policies.google.com/terms" target="_blank"
                                    rel="noopener noreferrer">Google
                                    Play
                                    Services</a></li>
                        </ul>
                    </div>
                </div>

                <div class="card mb-3">
                    <div class="card-body">
                        <h5 class="card-title">Google 로그인</h5>
                        <p>
                            당사 앱은 편의를 위해 Google로 로그인 옵션을 제공합니다. 이 과정에서 귀하의 이메일 주소에
                            접근하게 되며, 이는 당사 앱 내에서 고유 식별자로서에만 사용됩니다. 우리는 귀하의 프라이버시를
                            존중합니다. 귀하의 이메일은 절대 공유되거나 판매되지 않으며, 다른 목적으로 사용되지 않습니다.
                            Google 로그인 방식을 선택함으로써 귀하는 이메일 주소의 이와 같은 제한적 사용에 동의하게 됩니다.
                        </p>
                    </div>
                </div>

                <div class="card mb-3">
                    <div class="card-body">
                        <h5 class="card-title">책임 및 사용</h5>
                        <p>
                            Wi‑Fi에 접속할 수 없거나 데이터 요금제 잔여량이 없는 경우 앱이 완전한 기능으로 동작하지 않는 것에
                            대해서는 Florian Zopf가 책임을 질 수 없습니다.
                        </p>
                        <p>
                            마찬가지로, 앱 사용 방식에 대해서도 항상 책임질 수는 없습니다. 예를 들어, 기기가 충전된 상태를
                            유지하는 것은 사용자 책임입니다.
                        </p>
                    </div>
                </div>

                <div class="card mb-3">
                    <div class="card-body">
                        <h5 class="card-title">업데이트 및 종료</h5>
                        <p>
                            언젠가 우리는 앱을 업데이트할 수 있습니다. Florian Zopf는 귀하에게 관련성이 있거나 귀하의 기기에
                            설치된 Android 및 iOS 버전과 항상 호환되도록 앱을 업데이트할 것을 보장하지 않습니다.
                        </p>
                        <p>
                            그러나 귀하는 제공되는 경우 항상 애플리케이션 업데이트를 수락할 것을 약속합니다. 또한 우리는 언제든지
                            사전 통지 없이 앱 제공을 중단하고 사용을 종료할 수 있습니다.
                        </p>
                    </div>
                </div>

                <div class="card mb-3">
                    <div class="card-body">
                        <h5 class="card-title">사용 지침 및 최적의 기능</h5>
                        <p>
                            앱의 최적의 기능을 위해서는 앱 내에 제공되는 지침을 따르는 것이 중요합니다.
                        </p>
                        <p>
                            지침을 준수하지 않을 경우 결과가 부정확할 수 있으며 앱이 의도한 대로 작동하지 않을 수 있습니다.
                            지침을 따르지 않아 발생하는 문제나 불일치에 대해 Florian Zopf는 책임을 지지 않습니다.
                        </p>
                    </div>
                </div>

                <div class="card mb-3">
                    <div class="card-body">
                        <h5 class="card-title">이용약관 변경</h5>
                        <p>
                            앱과 서비스의 변경사항을 반영하기 위해 때때로 이용약관을 업데이트할 수 있습니다.
                        </p>
                        <p>
                            앱을 계속 사용하면 새로운 약관에 동의한 것으로 간주됩니다. 업데이트 사항을 확인하기 위해 주기적으로
                            약관을 검토해 주시기 바랍니다.
                        </p>
                    </div>
                </div>

                <div class="card mb-3">
                    <div class="card-body">
                        <h5 class="card-title">문의하기</h5>
                        <p>
                            약관에 대한 질문이나 제안이 있으시면 주저하지 말고
                            qwikvbt@gmail.com으로 연락해 주세요.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
